import Repository from "./Repository";
const resource = "/api/v1/coach";
export default {
  getCoachInfo(id) {
    let subUrl = `${resource}/${id}`;
    return Repository.sendReq({ method: "get", subUrl });
  },
  registerCoach(data) {
    let subUrl = `${resource}`;
    return Repository.sendReq({ method: "post", subUrl, data });
  }
};
